import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getNoticListAction, uploadNoticPictureAction } from "../action/noticAction";

export const noticReducer = (
  builder: ActionReducerMapBuilder<{
    noticList: string;
    uploadNoticPictureConfig: any
  }>
) => {
  builder.addCase(getNoticListAction.fulfilled, (state, { payload }) => {
    state.noticList = payload;
  });
  
  builder.addCase(uploadNoticPictureAction.fulfilled, (state, { payload }) => {
    state.uploadNoticPictureConfig = payload;
  });
};
